import type { IField, NumberInputSettings } from '../../types';

export const getMinValue = (
  inputField: IField & { inputSettings: NumberInputSettings }
): string => {
  return inputField.inputSettings?.minValue;
};

export const getMaxValue = (
  inputField: IField & { inputSettings: NumberInputSettings }
): string => {
  return inputField.inputSettings?.maxValue;
};
